import { useFooterContext } from 'contexts/CustomizeFooterContext';
import React from 'react';
import { isIosApp } from 'components/features/utils/userStatus';

type FooterProps = {
  showFooterMarginTop: boolean;
};

const NormalFooter: React.FC<FooterProps> = props => {
  return (
    <footer id="id_footer">
      {props.showFooterMarginTop && <div className="h-16" />}
      <div className="flex justify-center text-sm text-gray-300 bg-gray-800 py-1">
        (C) MINKABU THE INFONOID, Inc.
      </div>
    </footer>
  );
};

/* eslint-disable react/jsx-no-target-blank */
const DetailedFooter = () => {
  return (
    <>
      <div id="footer" className="bg-gray-800 py-4 px-2 text-white text-sm">
        <div className="container">
          <ul className="text-center mb-8">
            <li className="inline-block mr-4">
              <a href="https://minkabu.co.jp/" target="_blank" rel="noopener">
                運営会社
              </a>
            </li>
            <li className="inline-block mr-4">
              <a
                href="https://info.minkabu.jp/tw_terms/"
                target="_blank"
                rel="noopener">
                利用規約
              </a>
            </li>
            <li className="inline-block mr-4">
              <a
                href="https://minkabu.co.jp/privacy_policy"
                target="_blank"
                rel="noopener">
                プライバシーポリシー
              </a>
            </li>
            {!isIosApp() && (
              <>
                <li className="inline-block mr-4">
                  <a
                    href="https://info.minkabu.jp/economy/"
                    target="_blank"
                    rel="noopener">
                    特定商取引表示
                  </a>
                </li>
                <li className="inline-block mr-4">
                  <a
                    href="https://info.minkabu.jp/law/"
                    target="_blank"
                    rel="noopener">
                    ご利用上の注意（関連法規）
                  </a>
                </li>
                <li className="inline-block mr-4">
                  <a
                    href="https://livedoor.co.jp/sales/minkabu-sales-sheet.pdf"
                    target="_blank"
                    rel="noopener">
                    広告掲載・取扱商品
                  </a>
                </li>
                <li className="inline-block mr-4">
                  <a
                    href="https://support.minkabu.jp/hc/ja"
                    target="_blank"
                    rel="noopener">
                    ヘルプ/FAQ
                  </a>
                </li>
              </>
            )}
          </ul>
          <div className="copyright mb-4">
            <a
              href="https://minkabu.co.jp/"
              className="text-center"
              title="株式会社ミンカブ・ジ・インフォノイドコーポレートサイトへ"
              target="_blank"
              rel="noopener">
              <img
                loading="lazy"
                src="static/images/lp/min_infonoid_logo_white.svg"
                width="150"
                height="25"
                className="mx-auto"
                alt="ミンカブ・ジ・インフォノイド ロゴ"
              />
            </a>
            <div className="text-center">
              <span className="dptblc tar vabt">
                (C) MINKABU THE INFONOID, Inc.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/* eslint-enable react/jsx-no-target-blank */

const Footer = (props: FooterProps) => {
  const { type } = useFooterContext();
  switch (type) {
    case 'NORMAL':
      return <NormalFooter {...props} />;
    case 'DETAILED':
      return <DetailedFooter />;
  }
};

export default Footer;
